import QualityImg from '@/components/qualityImg/qualityImg.vue'
export default {
    name: 'goodsCard',
    data () {
        return {}
    },
    components: {
        QualityImg
    },
    props: {
        goods: {
            type: Object,
            default: {}
        }
    },
    created () {},
    activated () {},
    mounted () {}
}
